
import AppHeader from '@/components/Header.vue'
import { defineComponent, computed, ref, getCurrentInstance, onMounted, reactive, unref } from 'vue'
import PopupHeader from '@/components/popup/popup-header.vue'
import { showToastFail } from '@/utils/tools'
import { NewEvaluateParams, NewEvaluateData } from '@/types/malfunction-repair'
import { Icon, Toast, Dialog, Popup, Rate, Field } from 'vant'
import { PullRefresh } from 'vant'
import {
  cancelService,
  getNetWorkByGuid,
  getImageUrlByUuid,
  approveDzOrder,
  approveAllProtect,
  evalUateServiceOrder,
  getServiceDetail,
} from '@/apis/service'
import ServiceOrderEvaluation from '@/views/malfunction-repair/service-order-evaluation.vue'
import appHost from '@/utils/app'
import { useStore } from 'vuex'
export default defineComponent({
  name: 'ServiceDetail',
  components: {
    AppHeader,
    vanIcon: Icon,
    vanPullRefresh: PullRefresh,
    vanPopup: Popup,
    VanRate: Rate,
    VanField: Field,
    ServiceOrderEvaluation,
    PopupHeader,
  },
  setup() {
    const { proxy } = getCurrentInstance()
    const store = useStore()
    const loading = ref(false)
    // 设备信息 & 服务信息
    const deviceMsg = reactive({
      eq_model_logo: '',
      serial_number: '',
      eq_model_name: '',
      service_no: '',
      xcare: '',
      created_at: '',
      status: '',
      concrete_status: '',
      status_text: '',
    })
    const isEvaluate = ref(false)
    // 网点信息
    const networkMsg = reactive({
      repairName: '',
      reciveName: '',
      contact_phone: '',
      repair_warehouse_guid: '',
      repair_warehouse_type: '',
      receive_warehouse_guid: '',
      receive_warehouse_type: '',
    })
    // 全保审核
    const qualitative = reactive({
      guid: '',
      status: '',
      description: '',
      status_text: '',
      can_appeal: '',
      verified_at: '',
      confirmed_at: '',
    })
    // 定责审核
    const responsibility = reactive({
      guid: '',
      responsibility_type: '',
      responsibility_type_text: '',
      fault_type: '',
      analysis_at: '',
      description: '',
      can_auth_appeal: '',
      can_auth_reanalysis: '',
      can_client_reanalysis: '',
      type: '',
      imageList: [],
      can_client_appeal: false, // 能申诉即能同意操作
    })
    // 维修方案
    const repairList = ref([])
    // 备用机方案
    const standbyMachine = ref([])
    const showPopup = ref(false) // 是否显示评价弹窗
    // 待评价内容
    const eveluateData = reactive({
      showPopup: false,
      stars: 0,
      describe: '',
    })
    // 已评价内容
    const afterEvaluation = reactive({
      appraise: '',
      created_at: '',
      score: 0,
    })
    const isEnd = computed(() => {
      return deviceMsg.concrete_status === 'END'
    })
    // 收货地址
    const reciveExpress = reactive({
      name: '',
      phone: '',
      province: '',
      city: '',
      area: '',
      address: '',
    })
    let guid = proxy.$route.params.guid as string
    const onRefresh = async () => {
      await init()
      loading.value = false
    }
    // 跳转到定责我要申诉 type=1是全保
    const handleAppealResponsiblityPage = () => {
      if (!deviceMsg.serial_number || !responsibility.guid) {
        Toast('该设备缺少数据，请核实！')
        return
      }
      proxy.$router.push({
        path: `/serviceappeal/${deviceMsg.serial_number}/${responsibility.guid}/2`,
      })
    }
    // 跳转到全保审核 type=1是全保
    const handleAppealPage = () => {
      if (!deviceMsg.serial_number || !qualitative.guid) {
        Toast('该设备缺少数据，请核实！')
        return
      }
      proxy.$router.push({
        path: `/serviceappeal/${deviceMsg.serial_number}/${qualitative.guid}/1`,
      })
    }
    // 跳转到维修单
    const handleRepairOrder = (item: any) => {
      if (!item.guid) {
        Toast('数据错误，请联系管理员！')
        return
      }
      proxy.$router.push({ path: `/repairorder/${item.guid}` })
    }
    // 跳转到备用机单
    const handleReserveOrder = (item: any) => {
      if (!item.guid) {
        Toast('数据错误，请联系管理员！')
        return
      }
      proxy.$router.push({ path: `/reserveorder/${item.guid}` })
    }
    // 跳转到选择维修点
    const handleChangeService = () => {
      proxy.$router.replace({ path: `/chooseaddress/${proxy.$route.params.guid}` })
    }
    // 新待评价内容
    let newEveluateData = ref<NewEvaluateData>({
      repair_time: 0,
      receptionist_service_attitude: 0,
      repair_service_attitude: 0,
      environment: 0,
      process: 0,
      problem_solved: 0,
      responsibility_clear: 0,
      repair_reason_clear: 0,
      reasonable_amount: 0,
      appraise: '',
      created_at: '',
    })
    function newEveluateCloseHeaderHandler() {
      eveluateData.showPopup = false
    }
    // 初始化加载服务单方法
    const init = async () => {
      let toast = Toast({
        type: 'loading',
        message: '加载中...',
        forbidClick: true,
        duration: 0,
      })
      try {
        let result: any = await getServiceDetail(guid)
        console.log('getServiceDetail', result)

        deviceMsg.eq_model_logo = result.eq_model_logo
        deviceMsg.serial_number = result.serial_number
        deviceMsg.eq_model_name = result.eq_model_name
        deviceMsg.service_no = result.service_no
        deviceMsg.xcare = result.xcare
        deviceMsg.created_at = result.created_at
        deviceMsg.status_text = result.status_text
        deviceMsg.status = result.status
        deviceMsg.concrete_status = result.concrete_status

        if (result.repair_warehouse) {
          networkMsg.repairName = result.repair_warehouse.name
          networkMsg.reciveName = result.receive_warehouse.name
          networkMsg.contact_phone = result.repair_warehouse.contact_phone
          networkMsg.receive_warehouse_guid = result.receive_warehouse.guid
          networkMsg.repair_warehouse_guid = result.repair_warehouse.guid
          networkMsg.repair_warehouse_type = result.repair_warehouse.type
          networkMsg.receive_warehouse_type = result.receive_warehouse.type
        }
        if (result.qualitative && result.qualitative.guid) {
          qualitative.guid = result.qualitative.guid
          qualitative.status = result.qualitative.status
          qualitative.status_text = result.qualitative.status_text
          qualitative.description = result.qualitative.description
          qualitative.can_appeal = result.qualitative.can_appeal
          qualitative.verified_at = result.qualitative.verified_at
          qualitative.confirmed_at = result.qualitative.confirmed_at
        }
        if (result.responsibility && result.responsibility.guid) {
          responsibility.guid = result.responsibility.guid
          responsibility.responsibility_type = result.responsibility.responsibility_type
          responsibility.responsibility_type_text = result.responsibility.responsibility_type_text
          responsibility.fault_type = result.responsibility.fault_type
          responsibility.analysis_at = result.responsibility.analysis_at
          responsibility.description = result.responsibility.description
          responsibility.can_auth_appeal = result.responsibility.can_auth_appeal
          responsibility.can_auth_reanalysis = result.responsibility.can_auth_reanalysis
          responsibility.can_client_reanalysis = result.responsibility.can_client_reanalysis
          responsibility.type = result.responsibility.type
          responsibility.can_client_appeal = result.responsibility.can_client_appeal
          if (result.responsibility.images && result.responsibility.images.length >= 1) {
            await handleLoadImage(result.responsibility.images)
          }
        }
        if (result.repair && result.repair.length >= 1) {
          repairList.value = result.repair
        }
        if (result.standby_machine && result.standby_machine.length >= 1) {
          standbyMachine.value = result.standby_machine
        }
        if (result.concrete_status == 'END') {
          if (result.evaluation) {
            isEvaluate.value = true
            afterEvaluation.appraise = result.evaluation.appraise
            afterEvaluation.created_at = result.evaluation.created_at
            afterEvaluation.score = result.evaluation.score
          } else if (result.evaluation_v2) {
            isEvaluate.value = false
            newEveluateData.value.repair_time = result.evaluation_v2.repair_time
            newEveluateData.value.receptionist_service_attitude =
              result.evaluation_v2.receptionist_service_attitude
            newEveluateData.value.repair_service_attitude =
              result.evaluation_v2.repair_service_attitude
            newEveluateData.value.environment = result.evaluation_v2.environment
            newEveluateData.value.process = result.evaluation_v2.process
            newEveluateData.value.problem_solved = result.evaluation_v2.problem_solved
            newEveluateData.value.responsibility_clear = result.evaluation_v2.responsibility_clear
            newEveluateData.value.repair_reason_clear = result.evaluation_v2.repair_reason_clear
            newEveluateData.value.reasonable_amount = result.evaluation_v2.reasonable_amount
            newEveluateData.value.appraise = decodeURIComponent(
              result.evaluation_v2.appraise || '无'
            )
            newEveluateData.value.created_at = result.evaluation_v2.created_at
            console.log('init-newEveluateData', newEveluateData)
          }
        }
        if (result.receive_express) {
          reciveExpress.name = result.receive_express.name
          reciveExpress.phone = result.receive_express.phone
          reciveExpress.province = result.receive_express.province
          reciveExpress.city = result.receive_express.city
          reciveExpress.area = result.receive_express.area
          reciveExpress.address = result.receive_express.address
        }
        toast.clear()
      } catch (error: any) {
        console.log('init', error)
        let message = error && error.message ? error.message : '加载服务单失败，请刷新重试'
        toast.clear()
        Toast(message)
      }
    }
    // 取消服务单
    const handleCancelService = () => {
      Dialog.confirm({
        message: '确认取消服务单？',
        confirmButtonText: '确认取消',
        cancelButtonText: '我再想想',
        className: 'service-dialog',
        width: 304,
      })
        .then(async () => {
          try {
            let result = await cancelService(proxy.$route.params.guid as string)
            Dialog.close()
            Toast('取消服务单成功！')
          } catch (error: any) {
            Dialog.close()
            let message = error && error.message ? error.message : '取消服务单出错'
            Toast(message)
          }
        })
        .catch(() => {
          Dialog.close()
        })
    }
    // 跳转到查看评价页面
    const handleChekEvaluate = function () {
      if (isEvaluate.value) {
        proxy.$router.push({ path: '/servicevaluate', query: afterEvaluation })
      } else {
        // 新评价
        eveluateData.showPopup = true
        console.log('newEveluateData', newEveluateData)
      }
    }
    const handleRepairWare = async () => {
      if (!networkMsg.repair_warehouse_guid) {
        Toast('找不到该网点信息，请核实！')
        return
      }
      proxy.$router.push({
        path: `/fault/pointdetail/${networkMsg.repair_warehouse_guid}`,
        query: { type: networkMsg.repair_warehouse_type },
      })
    }
    const handleReciveWare = async () => {
      if (!networkMsg.receive_warehouse_guid) {
        Toast('找不到该网点信息，请核实！')
        return
      }
      proxy.$router.push({
        path: `/fault/pointdetail/${networkMsg.receive_warehouse_guid}`,
        query: { type: networkMsg.receive_warehouse_type },
      })
    }
    const handleCallRepair = () => {
      if (!networkMsg.contact_phone) {
        Toast('维修网点信息错误')
        return
      }
      appHost.postCallPhone(networkMsg.contact_phone, networkMsg.repairName)
    }
    const handleLoadImage = async (uids: any[]) => {
      let param = {
        res_uids: uids,
      }
      try {
        let result: any = await getImageUrlByUuid(param)
        responsibility.imageList = result || []
      } catch (error) {
        console.log(error)
      }
    }
    // 确认定责审核结果
    const handleApproveReview = async () => {
      let toast = Toast({
        type: 'loading',
        message: '加载中...',
        forbidClick: true,
        duration: 0,
      })
      try {
        let result = await approveDzOrder(responsibility.guid)
        toast.clear()
        Toast('确认成功')
        init()
      } catch (error: any) {
        let message = error && error.message ? error.message : '操作失败'
        toast.clear()
        Toast(message)
      }
    }
    // 全保确认审核结果
    const handleApproveAllProtect = async () => {
      let toast = Toast({
        type: 'loading',
        message: '加载中...',
        forbidClick: true,
        duration: 0,
      })
      try {
        let result = await approveAllProtect(qualitative.guid)
        toast.clear()
        Toast('确认成功')
        init()
      } catch (error: any) {
        let message = error && error.message ? error.message : '操作失败'
        toast.clear()
        Toast(message)
      }
    }
    const handleClikBack = () => {
      if (proxy.$route.query.from && proxy.$route.query.from == 'app') {
        appHost.goAppBack()
        return
      }
      proxy.$router.back()
    }
    // 查看提单内容
    const handleCheckOrder = () => {
      proxy.$router.push({ path: `/fault/content/${proxy.$route.params.guid}` })
    }
    // 弹出服务单评价
    const handleEvaluate = () => {
      eveluateData.showPopup = true
    }
    function newEvaluateVerify() {
      let flag = true
      let newEveluateDataUnref = unref(newEveluateData)
      Object.keys(newEveluateDataUnref).forEach((_) => {
        let item = _ as keyof typeof newEveluateDataUnref
        if (item !== 'appraise' && newEveluateDataUnref[item] === 0) {
          flag = false
        }
      })
      return flag
    }
    // 评价
    const handleSubmitEvaluate = async () => {
      if (!newEvaluateVerify()) {
        showToastFail('请对服务进行评分')
        return
      }
      let params: NewEvaluateParams = {
        repair_time: newEveluateData.value.repair_time,
        receptionist_service_attitude: newEveluateData.value.receptionist_service_attitude,
        repair_service_attitude: newEveluateData.value.repair_service_attitude,
        environment: newEveluateData.value.environment,
        process: newEveluateData.value.process,
        problem_solved: newEveluateData.value.problem_solved,
        responsibility_clear: newEveluateData.value.responsibility_clear,
        repair_reason_clear: newEveluateData.value.repair_reason_clear,
        reasonable_amount: newEveluateData.value.reasonable_amount,
        appraise: encodeURIComponent(newEveluateData.value.appraise),
      }
      let toast = Toast({
        type: 'loading',
        message: '加载中...',
        forbidClick: true,
        duration: 0,
      })
      try {
        let result = await evalUateServiceOrder(proxy.$route.params.guid as string, params)
        toast.clear()
        Toast('提交成功')
        init()
        eveluateData.showPopup = false
      } catch (error) {
        console.log(error)
        toast.clear()
        Toast('评价失败')
      }
    }
    // 取消评价窗口
    const handleCancelEvaluate = () => {
      eveluateData.showPopup = false
    }
    // 跳转到分析报告界面
    const handleReporterPage = () => {
      proxy.$router.push({ path: `/fault/report/${responsibility.guid}` })
    }
    // 相当于原来的mounted
    onMounted(() => {
      init()
    })
    return {
      loading,
      deviceMsg,
      networkMsg,
      qualitative,
      responsibility,
      repairList,
      standbyMachine,
      showPopup,
      eveluateData,
      pagePaddingTop: store.getters.pagePaddingTop,
      reciveExpress,
      onRefresh,
      handleAppealResponsiblityPage,
      handleRepairOrder,
      handleChangeService,
      handleCancelService,
      handleChekEvaluate,
      handleReserveOrder,
      handleRepairWare,
      handleReciveWare,
      handleCallRepair,
      handleAppealPage,
      handleApproveReview,
      handleApproveAllProtect,
      handleClikBack,
      handleCheckOrder,
      handleEvaluate,
      handleSubmitEvaluate,
      handleCancelEvaluate,
      handleReporterPage,
      isEvaluate,
      isEnd,
      newEveluateData,
      newEveluateCloseHeaderHandler,
    }
  },
})
